"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKicadSch = validateKicadSch;
const constants_1 = require("../constants");
const validateKicadV6SchemaFile_1 = require("../common/validateKicadV6SchemaFile");
function validateKicadSch(filename, fileContents) {
    if (!filename.endsWith('.kicad_sch') || !fileContents.startsWith(constants_1.KicadSchPreamble)) {
        throw new Error('Invalid kicad sch');
    }
    const result = (0, validateKicadV6SchemaFile_1.validateKicadV6SchemaFile)(fileContents, true);
    if (filename.startsWith('_autosave-')) {
        result.skipReason = 'Autosave files are not supported';
    }
    return result;
}
//# sourceMappingURL=v6schValidate.js.map